export const POST_ROUTES = {
	FEED: "/feed",
	DRAFTS: "/drafts",
	SAVED: "/saved",
	DETAIL: "/posts/:postId",
} as const;
